export * from './get-src-configuration';
